import { MaybeRef, toRef } from "vue";

import { useFetch } from "@/composables/tanstack/use-fetch";
import KiliApi from "@/data/api/kili/kili-api";
import { SitesQueryKeys } from "@/data/api/kili/sites/sites-query-keys";

export function useFetchSiteInstalledApplianceCategories() {
  const query = useFetch(
    (siteId: MaybeRef<number>) => {
      const _siteId = toRef(siteId);
      return SitesQueryKeys.installedApplianceCategories(_siteId.value);
    },
    async (siteId: MaybeRef<number>) => {
      const _siteId = toRef(siteId);
      return await KiliApi.getSiteInstalledApplianceCategories({
        params: { siteId: _siteId.value },
      });
    },
  );

  return {
    ...query,
    fetch: async (siteId: MaybeRef<number>) => {
      const _siteId = toRef(siteId);
      if (_siteId.value <= 0) return;

      return await query.fetch(siteId);
    },
  };
}
